import { Button } from '@repo/shadcn';

import { IwForm } from '@/components/form';
import { TextField } from '@/components/form/fields';
import { useModal } from '@/hooks';

import { SupplierFormSchema, SupplierFormType } from './create-supplier.schema';

type SupplierFormProps = {
    isLoading?: boolean;
    onSubmit: (data: SupplierFormType) => void;
    initialValues: Partial<SupplierFormType>;
    isEditMode?: boolean;
};

export const SupplierForm = ({
    isLoading,
    onSubmit,
    initialValues,
    isEditMode = false,
}: SupplierFormProps) => {
    const { closeModal } = useModal();

    const renderSubmitText = () => {
        if (isLoading) {
            if (isEditMode) {
                return 'Updating...';
            }
            return 'Creating...';
        }
        if (isEditMode) {
            return 'Update';
        }
        return 'Create';
    };

    return (
        <IwForm
            schema={SupplierFormSchema}
            initialValues={initialValues}
            onSubmit={(data) => {
                onSubmit(data as SupplierFormType);
            }}
        >
            <div className=" mt-5 grid grid-cols-1 gap-5">
                <TextField<SupplierFormType>
                    name="name"
                    label="Name"
                    placeholder="name"
                />
                <TextField<SupplierFormType>
                    name="email"
                    label="Email"
                    placeholder="email"
                />
                <TextField<SupplierFormType>
                    name="phone_number"
                    label="Phone Number"
                    placeholder="phone number"
                />
                <TextField<SupplierFormType>
                    name="address"
                    label="Address"
                    placeholder="address"
                />
            </div>
            <div className="mt-5 flex justify-end gap-2">
                <Button variant="outline" type="button" onClick={closeModal}>
                    Cancel
                </Button>
                <Button type="submit" disabled={isLoading}>
                    {renderSubmitText()}
                </Button>
            </div>
        </IwForm>
    );
};
